import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getPasuedMissionAction = createAsyncThunk(
    'get-paused-mission',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/get-paused-mission`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getPasuedMissionSlice = createSlice({
    name: 'get-paused-mission',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getPasuedMissionAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getPasuedMissionAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getPasuedMissionAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getPasuedMissionReducer = getPasuedMissionSlice.reducer    